<template>
  <div>
    <div class="manualurg">
      <!-- 头部查询表单 -->
      <div class="headForm">
        <h4
          style="    color: #2e3458;
    font-size: 16px;
    font-weight: bold;"
        >
          手动催评
        </h4>
        <div style="padding-top:20px;">
          <input-form
            :inputData="inputData"
            :pageName="pageName"
            :time="time"
            @toParentVal="searchForm"
            ref="searchForm"
            :btnPosition1="true"
          ></input-form>
        </div>
      </div>

      <div class="content">
        <!-- 表格内容 -->
        <div class="tableWrapper">
          <!-- 头部按钮 -->
          <div class="headBtn">
            <div class="leftBtn">
              <button class="b1" v-zoom="{ from: pageName, name: '发送短信' }" @click.prevent="handleSendSms">发送短信</button>
              <button class="b2" v-zoom="{ from: pageName, name: '按查询结果发送短信' }" @click.prevent="handleSearchSendSms">
                按查询结果发送短信
              </button>
              <button class="b3" v-zoom="{ from: pageName, name: '加入黑名单' }" @click="joinBackListChange">加入黑名单</button>
              <!-- <button class="b2" @click="refreshBata ">更新数据</button> -->
            </div>
          </div>

          <!-- 表格 -->
          <!-- 表单部分 -->
          <div class="elTable">
            <el-table
              v-loading="tableLoading"
              tooltip-effect="light"
              :data="tableData"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
              style="border: 1px solid #eee"
              empty-text="暂无数据"
              @selection-change="handleSelectionChange"
            >
              <template slot="empty">
                <div>
                  <img src="@/assets/images/default/暂无任何数据.png" />
                  <span style="margin-left: -140px">暂无任何数据</span>
                </div>
              </template>
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="商品信息" width="200">
                <template slot-scope="scope">
                  <div class="desc">
                    <span v-if="scope.row.itemInfo.length == 0" class="span1"></span>
                    <span v-if="scope.row.itemInfo.length != 0" @click="newUrl(scope.row.itemInfo[0].itemUrl)" class="span1">
                      {{ scope.row.itemInfo[0].skuName }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="orderPayment" label="总金额">
                <template slot-scope="scope">
                  <span style="color:rgb(254, 77, 69)">¥{{ scope.row.orderPayment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单信息" width="230">
                <template slot-scope="scope">
                  <div>
                    <span>订单编号：</span>{{ scope.row.orderId }}<br />
                    <span>完成时间：</span>{{ scope.row.finishTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="!venderType" label="买家信息" width="480px">
                <template slot-scope="scope">
                  <div class="box" style="position: relative;" v-if="!scope.row.fullNameState">
                    <span>{{ scope.row.fullName?scope.row.fullName.substring(0, 20):'' }}</span>
                  </div>
                  <span v-else>{{ scope.row.fullName?scope.row.fullName.substring(0, 20):'' }}</span>
                  <div class="box2" style="position: relative; margin-top:4px" v-if="!scope.row.mobileState">
                    <span>{{ (scope.row.mobile || "--") | mobileEllipsis }}</span>
                  </div>
                  <span v-else>{{ scope.row.mobile || "--" }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="crtime1" label="评价状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.isBuyerRate === 1 ? "已评" : "未评" }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="短信记录">
                <template slot-scope="scope">
                  <span v-if="scope.row.count > 0">{{ scope.row.count }}条</span>
                  <span v-else>0条</span>
                </template>
              </el-table-column>
              <el-table-column prop="venderRemark" label="备注"> </el-table-column>
              <el-table-column label="操作" width="220px">
                <template slot-scope="scope">
                  <!-- <span class="operation" style="margin-right:8px" v-zoom="{ from: pageName, name: '催评链接' }" @click="hadnleUrgingLink(scope.row)"
                    >催评链接</span
                  > -->
                  <span
                    class="operation"
                    style="margin-right:8px"
                    v-zoom="{ from: pageName, name: '订单详情' }"
                    @click="handleOrderDetail(scope.row.orderId)"
                    >订单详情</span
                  >
                  <span v-if="!venderType" class="operation" v-zoom="{ from: pageName, name: '编辑备注' }" @click="editRemark(scope.row)">编辑备注</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              :current-page="current"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              class="pagination"
              :total="total"
            >
            </el-pagination>
          </div>

          <!-- <table class="table" cellpadding="0" cellspacing="0" v-loading="tableLoading">
                        <th>
                            <el-checkbox v-model="tableCheckAll" style="marginRight: 12px;" @change="checkAll"></el-checkbox>
                            <td style="flex: 6;flex-shrink:0;">商品信息</td>
                            <td style="flex: 4;flex-shrink:0;">订单信息</td>
                            <td style="flex: 8;flex-shrink:0;">买家信息</td>
                            <td style="flex: 2;flex-shrink:0;">评价状态</td>
                            <td style="flex: 2;flex-shrink:0;">短信记录</td>
                            <td style="flex: 3;flex-shrink:0;">备注</td>
                            <td style="flex: 6;flex-shrink:0;">操作</td>
                        </th>
                         <div v-if="tableData.length==0" style="text-align: center;">
                         <img src="@/assets/images/default/暂无任何数据.png" />
                         <span style="margin-left: -140px">暂无任何数据</span>
                         </div>
                        <tbody>                        
                            <td v-for="(item, index) in tableData" :key="item.orderId">
                                <div class="tit">
                                    <el-checkbox v-model="item.checkVal" style="marginRight: 12px;" @change="checkOne($event, index)"></el-checkbox>
                                    <span style="color: #FE4D45;">总金额：¥{{item.orderPayment}}</span>
                                </div>

                                <div class="tableCnt">
									<p style="flex: 6;" class="desc">
									<span v-for="(data,idx) in item.itemInfo" :key="data.skuId + idx" v-if="idx <= 2" @click="newUrl(data.itemUrl)" class="span1">  
                                        {{data.skuName}}   
                                    </span>
									</p>
									<p style="flex: 4;" class="desc">
                                        <span style="margin: 0 px;">订单编号：{{item.orderId}}</span>
                                    <span>完成时间：{{item.finishTime}}</span>
                                    </p>
									<div class="info" style="flex: 2;">
                                        <div class="box" style="position: relative;" v-if="!item.fullNameState">
										    <span>{{item.fullName.substring(0, 20)}}</span>
                                        </div>
                                        <span v-else>{{item.fullName.substring(0, 20)}}</span>
                                        <div class="box2" style="position: relative; margin-top:4px" v-if="!item.mobileState">
										    <span>{{item.mobile || '--'}}</span>
                                        </div>
                                        <span v-else>{{item.mobile || '--'}}</span>
									</div>

									<span style="flex: 2;">{{item.isBuyerRate === 1 ? '已评' : '未评'}}</span>
									<span style="flex: 2;" v-if="item.record > 0">{{item.record}}条</span>
									<span style="flex: 2;" v-else>0条</span>
									<span style="flex: 3;">{{item.venderRemark}}</span>
									
									<p style="flex:6;" class="handle">
										<span class="operation" v-zoom='{from:pageName,name:"催评链接"}' @click="hadnleUrgingLink(item)">催评链接</span>
										<span class="operation" v-zoom='{from:pageName,name:"订单详情"}' @click="handleOrderDetail(item.orderId)">订单详情</span>
										<span class="operation" v-zoom='{from:pageName,name:"编辑备注"}' @click="editRemark(item)">编辑备注</span>
									</p>
                                </div>
                            </td>
                        
                        </tbody>    
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                             background
                            :current-page="current"
                            :page-sizes="[10, 30, 50, 100]"
                            :page-size="size"
                            layout="total, sizes, prev, pager, next, jumper"
                            class="pagination"
                            :total="total">
                        </el-pagination>

                    </table> -->
        </div>
      </div>
    </div>
    <!-- 批量发送短信抽屉  -->
    <send-sms
      :drawer="drawer"
      @close="drawerClose"
      taskName="手动催评"
      :checkData="checkData"
      :sendType="sendType"
      :count="checkCount"
      :dataFrom="7"
      :searchForm="searchFormData"
    >
    </send-sms>
    <!-- 加入黑名单 -->
    <my-popup title="提示" width="400" :flag="joinBackListShow" @close="joinBackListShow = false">
      <div class="JoinBackList">
        <div class="tipsBox">
          <img
            src="../../assets/images/tips_icon.png"
            style="width: 22px;
    height: 22px;"
            class="tips"
          />
          <span>确定拉黑订单吗？</span>
        </div>
        <div class="btnBox">
          <button class="cancelBtn" @click="joinBackListShow = false">取消</button>
          <button class="confirmBtn" @click="handleJoinBackList">确认</button>
        </div>
      </div>
    </my-popup>
    <!-- 催评链接 -->
    <my-popup title="催价链接" width="764" :flag="urgingLinkShow" @close="urgingLinkChange">
      <div class="urgingLink">
        <div class="item">
          <span class="link">https://club.jd.com/myJdcomments/orderVoucher.action?ruleid={{ linkData.id }}</span>
          <button class="copyBtn" @click="handleCopyLink('https://club.jd.com/myJdcomments/orderVoucher.action?ruleid=' + linkData.id, $event)">
            复制催评链接
          </button>
        </div>
        <div class="item">
          <span class="link">{{ linkData.link }}</span>
          <button class="copyBtn" @click="handleCopyLink(linkData.link, $event)">复制催评短链接</button>
        </div>
      </div>
    </my-popup>
    <!-- 编辑备注 -->
    <my-popup title="备注" width="570" :flag="remarkShow" @close="remarksChange">
      <div class="remarks">
        <p>备注:</p>
        <el-input type="textarea" :rows="4" placeholder="请输入备注内容" maxlength="50" show-word-limit v-model="editRemarkform.venderRemark">
        </el-input>
        <div class="footBtns">
          <button class="cancelBtn" @click="remarkShow = false">取消</button>
          <button class="confirmBtn" @click="handleEditReamrk">确认</button>
        </div>
      </div>
    </my-popup>
    <!-- 订单详情 -->
    <my-popup title="订单详情" width="1090" :flag="orderDetail" @close="orderDetailChange" v-if="orderDetail">
      <div class="orderDetails">
        <p class="tips"><i></i>订单信息</p>
        <div class="details">
          <span>订单编号:{{ orderDetialsData.orderId | checkNull }}</span>
          <span>付款方式:{{ orderDetialsData.payType | checkNull }}</span>
          <span>送货类型:{{ orderDetialsData.deliveryType | checkNull }}</span>
          <!-- <span>买家账号:{{orderDetialsData.pin}}</span> -->
          <!-- <span>买家姓名:{{orderDetialsData.fullName}}</span> -->
          <span>
            <span>买家账号:</span>
            <span class="box" v-if="!orderDetialsData.pinState && !venderType">
              <span class="hover-show" @click="showInfo(1, orderDetialsData, 0, 'detail')" style="width: 110px" :style="{ background: globalBG }">
                显示买家账号
              </span>
              <span>{{ orderDetialsData.desensitizePin | checkNull }}</span>
            </span>
            <span v-else>{{ orderDetialsData.desensitizePin | checkNull }}</span>
          </span>
          <span>
            <span>买家姓名:</span>
            <span class="box" v-if="!orderDetialsData.fullNameState">
              <!-- <span
                                class="hover-show"
                                @click="showInfo(2, orderDetialsData, 0,'detail')"
                                style="width: 110px"
                                :style="{ background: globalBG }"
                            >
                                显示买家姓名
                            </span> -->
              <span>{{ orderDetialsData.fullName | checkNull }}</span>
            </span>
            <span v-else>{{ orderDetialsData.fullName | checkNull }}</span>
          </span>
          <span>
            <span>买家号码:</span>
            <span class="box" v-if="!orderDetialsData.mobileState">
              <!-- <span
                                class="hover-show"
                                @click="showInfo(0, orderDetialsData, 0,'detail')"
                                style="width: 110px"
                                :style="{ background: globalBG }"
                            >
                                显示手机号码
                            </span> -->
              <span>{{ (orderDetialsData.mobile || "--") | mobileEllipsis }}</span>
            </span>
            <span v-else>{{ orderDetialsData.mobile || "--" }}</span>
          </span>
          <span>订单总金额:{{ orderDetialsData.orderTotalPrice | checkNull }}</span>
          <span>实付金额:{{ orderDetialsData.orderPayment | checkNull }}</span>
          <span>优惠金额:{{ orderDetialsData.sellerDiscount | checkNull }}</span>
          <span>邮费:{{ orderDetialsData.freightPrice | checkNull }}</span>
          <span>订单状态:{{ orderDetialsData.orderStateRemark | checkNull }}</span>
          <span>发票信息:{{ orderDetialsData.invoiceInfo | checkNull }}</span>
          <span>下单时间:{{ orderDetialsData.orderStartTime | checkNull }}</span>
          <span>最后修改时间:{{ orderDetialsData.modified | checkNull }}</span>
          <span>付款时间:{{ orderDetialsData.paymentConfirmTime | checkNull }}</span>
          <span>买家备注:{{ orderDetialsData.orderRemark | checkNull }}</span>
          <span>商家备注:{{ orderDetialsData.venderRemark | checkNull }}</span>
          <span>所属省份:{{ orderDetialsData.province | checkNull }}</span>
          <span>
            <span>详细地址:</span>
            <span class="box" v-if="!orderDetialsData.fullAddressState">
              <!-- <span
                                class="hover-show"
                                @click="showInfo(3, orderDetialsData,0,'detail')"
                                style="width: 110px"
                                :style="{ background: globalBG }"
                            >
                                显示详细地址
                            </span> -->
              <span>{{ orderDetialsData.fullAddress | checkNull }}</span>
            </span>
            <span v-else>{{ orderDetialsData.fullAddress | checkNull }}</span>
          </span>
          <!-- <span>详细地址:{{orderDetialsData.fullAddress}}</span> -->
        </div>
        <p class="tips"><i></i>商品详情</p>
        <el-table :data="orderDetialsData.itemInfoList" header-row-class-name="row" border style="width: 100%; margin-bottom: 16px;" max-height="150">
          <el-table-column prop="skuName" label="商品的名称+SKU规格" width="600"></el-table-column>
          <el-table-column prop="itemTotal" label="数量"></el-table-column>
          <el-table-column prop="jdPrice" label="SKU的京东价"></el-table-column>
        </el-table>
        <p class="tips"><i></i>优惠类型</p>
        <el-table :data="orderDetialsData.couponDetailList" border style="width: 100%">
          <el-table-column prop="couponType" label="优惠类型"></el-table-column>
          <el-table-column prop="skuId" label="京东sku编号"></el-table-column>
          <el-table-column prop="couponPrice" label="优惠金额"></el-table-column>
        </el-table>
      </div>
    </my-popup>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import sendSms from "./components/sendSms.vue";
import myPopup from "@/components/myPopup";
import { getPopCommentReplyList, getNoPopCommentOrderList, smsCount, editRemark, getShortLink } from "@/api/serviceCenter/popCommentController";
import { getOrderDetail } from "@/api/tbOrder";
import { insertBlack } from "@/api/smsBlackList";
import clip from "../../utils/clipboard";
import { sensitive } from "@/api/tbOrder";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    inputForm,
    sendSms,
    myPopup,
  },
  data() {
    return {
      pageName: "售后中心-手动催评",
      time: 1,
      multipleSelection: [],
      inputData: [
        // 表单项
        {
          name: "买家姓名:",
          val: "fullName",
          placeholder: "请输入买家姓名",
        },
        {
          name: "订单编号:",
          val: "orderId",
          placeholder: "请输入订单编号",
        },

        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
        },
        {
          name: "订单金额:",
          iptArr: [
            { val: "orderPaymentStart", placeholder: "请输入" },
            { val: "orderPaymentEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "SKU ID:",
          val: "skuIds",
          isComma: true,
          placeholder: "多个SKU用英文逗号隔开",
        },
        {
          name: "下单时间:",
          myDate: true,
          val: ["orderStartTimeStart", "orderStartTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "完成时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      tableData: [
        // 表格数据
      ],
      // venderType: this.$store.state.loginUserInfo.venderType,
      searchFormData: {}, // 存储按查询结果发送短信需要的查询参数
      tableLoading: false,
      tableCheckAll: false, // 表格全选
      current: 1,
      size: 10,
      total: 0,
      debounce: false,
      updata: false,
      sendType: 1, // 发送类型 1. 按条件查询 2.勾选
      // 存储复选框选中的表格数据
      checkData: [],
      // 存储复选框选中人数
      checkCount: 0,
      drawer: false, // 发送短信抽屉状态控制
      urgingLinkShow: false, // 催评链接状态控制
      // 编辑备注状态控制 ----- 内容
      remarkShow: false,
      text: "",
      editRemarkform: {
        venderRemark: "",
        orderId: 0,
      },
      // 加入黑名单状态控制
      joinBackListShow: false,
      // 订单详情状态控制
      orderDetail: false,
      // 订单详情表格
      orderDetialsData: null,
      typeData: [{ type: "满减优惠", sku: "456489216564684", money: "69" }],
      // 存储催评链接
      linkData: {
        id: null,
        link: "",
      },
      // pickerOptionsEnd: {
      // 	disabledDate: (time) => {
      // 		if (this.postForm.startDate) {
      // 			return time.getTime() < new Date(this.postForm.startDate).getTime();
      // 		}
      // 	},
      // },
      // pickerOptionsStart: {
      // 	disabledDate: (time) => {
      // 		if (this.postForm.endDate) {
      // 			return time.getTime() > new Date(this.postForm.endDate).getTime();
      // 		}
      // 	},
      // },
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },

  filters: {
    checkNull(v) {
      if (v === 0) {
        return v
      } else if (v === "") {
        return "--"
      } else if (!v) {
        return "--"
      } else {
        return v
      }
    },
  },

  created() {
    // 埋点
    this.buriedPoint(1, '手动催评', '售后中心', '评价管理')
  },
  mounted() {
    this.$refs.searchForm.submitForm("formSearch");
  },
  methods: {
    newUrl(url) {
      window.open(url);
    },
    // 信息显示全 type 0 手机号码, 1 pin（买家昵称）, 2 买家姓名, 3 地区
    showInfo(type, row, index, moduleType) {
      // console.log(type, row, index);
      // console.log(this.tableData[index]);
      // return
      var param = {
        orderId: row.orderId,
        type,
      };

      sensitive(param).then((res) => {
        if (res.code == "1") {
          if (moduleType == "detail") {
            if (type == "2") {
              // 买家姓名
              this.orderDetialsData.fullName = res.data.fullName;
              this.orderDetialsData.fullNameState = true;
              console.log(this.tableData[index].fullName);
            } else if (type == "0") {
              // 手机号
              this.orderDetialsData.mobile = res.data.mobile;
              this.orderDetialsData.mobileState = true;
            } else if (type == "1") {
              // pin
              console.log(res.data);
              this.orderDetialsData.pin = res.data.pin;
              this.orderDetialsData.pinState = true;
            } else if (type == "3") {
              // 地址
              this.orderDetialsData.fullAddress = res.data.fullAddress;
              this.orderDetialsData.fullAddressState = true;
            }
          } else {
            if (type == "2") {
              // 买家姓名
              this.tableData[index].fullName = res.data.fullName;
              this.tableData[index].fullNameState = true;
              console.log(this.tableData[index].fullName);
            } else if (type == "0") {
              // 手机号
              this.tableData[index].mobile = res.data.mobile;
              this.tableData[index].mobileState = true;
            }
          }
        }
      });
    },
    // 更新数据
    async refreshBata() {
      this.updata = true;
      this.$refs.searchForm.submitForm("formSearch");
    },
    // 获取订单列表
    getOrderList(form, state) {
      this.tableLoading = true;
      form.size = this.size;
      form.current = state ? 1 : this.current;
      this.searchFormData = form;
      getNoPopCommentOrderList(form).then((res) => {
        if (res && res.code == 1) {
          const { records, total } = res.data;
          const ids = records.map((item) => item.orderId);
          this.tableData = records;

          console.log(  this.tableData,'------------');
          // 获取每条数据对应的短信条数
          smsCount({ orderIds: ids.join(",") }).then((result) => {
            console.log(result);
          });
          this.total = total;
          if (this.updata) {
            this.$message.success("数据更新成功");
            this.updata = false;
          }
          this.tableLoading = false;
        }
      });
    },
    /**
     * 表单查询
     */
    searchForm(form, state) {
      console.log(state);
      this.getOrderList(form, state);
    },
    /**
     * 全选
     */
    checkAll(flag) {
      flag ? (this.checkData = this.tableData) : (this.checkData = []);
      this.tableData.forEach((item) => {
        if (flag) {
          item.checkVal = true;
        } else {
          item.checkVal = false;
        }
      });
    },
    // 监听表格多选事件
    handleSelectionChange(val) {
      // console.log(val);
      this.multipleSelection = val;
      this.checkData = this.multipleSelection;
    },
    /**
     * 单选
     */
    checkOne(flag, index) {
      if (flag) {
        this.checkData.push(this.tableData[index]);
        const status = this.tableData.some((item) => item.checkVal === false);
        status ? (this.tableCheckAll = false) : (this.tableCheckAll = true);
      } else {
        this.checkData = this.checkData.filter((item) => {
          return item.orderId != this.tableData[index].orderId;
        });
        this.tableCheckAll = false;
      }
    },
    // 发送短信
    handleSendSms() {
      if (this.checkData.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      if (this.checkData.length <= 0) {
        this.$message.warning("请勾选订单数据");
        return;
      }
      this.sendType = 2;
      this.checkCount = this.checkData.length;
      this.drawer = true;
    },
    // 按查询结果发送短信
    handleSearchSendSms() {
      // if (this.tableData.length <= 0) return;
      if (this.tableData.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.sendType = 1;
      this.checkCount = this.total;
      this.drawer = true;
    },
    /**
     * 分页
     */
    handleSizeChange(val) {
      this.size = val;
      this.current = 1;
      this.$refs.searchForm.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.searchForm.submitForm("formSearch");
    },
    /**
     * 发送短信抽屉隐藏
     */
    drawerClose() {
      this.drawer = false;
    },
    /**
     * 加入黑名单弹层隐藏
     */
    joinBackListChange() {
      if (this.checkData.length <= 0) {
        this.$message.warning("请先勾选订单");
        return;
      }
      this.joinBackListShow = true;
    },
    // 加入黑名单
    handleJoinBackList() {
      if (this.debounce == true) return;
      const params = {
        pins: this.checkData.map((item) => item.pin),
        type: 1,
      };
      insertBlack(params).then((res) => {
        if (res && res.code == 1) {
          // this.$message.success("加入黑名单成功");
          this.$message.success("添加成功" + res.data.sucessNum + "个; 失败" + res.data.fialNum + "个");
          this.joinBackListShow = false;
          this.debounce == false;
          this.$refs.searchForm.submitForm("formSearch");
        }
      });
      this.debounce = true;
    },
    // 催评链接
    hadnleUrgingLink(data) {
      this.linkData.id = data.orderId;
      // 获取短链接
      const params = {
        url: `https://club.jd.com/myJdcomments/orderVoucher.action?ruleid=${data.orderId}`,
        isJdApi: 1,
        shortLinkType: 1,
        isSmartLink: 0,
        isPrecision: 0,
      };
      getShortLink(params).then((res) => {
        this.linkData.link = res && res.data.shortLink;
        this.urgingLinkShow = true;
      });
    },
    // 复制催评链接
    handleCopyLink(link, e) {
      clip(link, e);
      this.$message.success("复制成功");
    },
    /**
     * 催评链接弹层隐藏
     */
    urgingLinkChange() {
      this.urgingLinkShow = false;
    },
    // 编辑备注同步id
    editRemark(item) {
      this.editRemarkform.orderId = item.orderId;
      this.remarkShow = true;
      this.editRemarkform.venderRemark = item.venderRemark;
    },
    // 备注请求
    handleEditReamrk() {
      // if (!this.editRemarkform.venderRemark) return;
      if (this.editRemarkform.venderRemark === "") {
        this.editRemarkform.venderRemark = " ";
      }
      editRemark(this.editRemarkform).then((res) => {
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.remarkShow = false;
          this.editRemarkform.venderRemark = null;
          this.$refs.searchForm.submitForm("formSearch");
        }
      });
    },
    /**
     * 编辑备注弹层隐藏
     */
    remarksChange() {
      this.remarkShow = false;
    },
    handleOrderDetail(id) {
      getOrderDetail(id).then((res) => {
        this.orderDetialsData = res && res.data;
        this.orderDetail = true;
      });
    },
    // 订单详情弹窗隐藏
    orderDetailChange() {
      this.orderDetail = false;
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  .hover-show {
    display: none;
    position: absolute !important;
    left: 0%;
    top: 50%;
    text-align: center;
    transform: translate(0, -50%);
    color: #fff !important;
    cursor: pointer;
    padding: 1px 10px;
    border-radius: 4px;
    z-index: 999;
  }
  &:hover {
    .hover-show {
      display: inline-block;
    }
  }
}
button {
  border: none;
  background-color: white;
  outline: none;
  padding: 0;
  margin: 0;
  border-radius: 3px;
  cursor: pointer;
  text-align: center;
}
.manualurg {
  box-sizing: border-box;
  padding: 10px 20px 31px 20px;
  min-width: 1080px;
  .headForm {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 0 0 30px 0;
    border-radius: 6px;
    h4 {
      box-sizing: border-box;
      padding-left: 28px;
      margin: 0;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      color: #2e3458;
    }
  }
  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .tableWrapper {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 24px 28px 30px;
      .headBtn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        button {
          margin: 0;
          padding: 0 12px;
          height: 32px;
          line-height: 30px;
          border: none;
          outline: none;
          border-radius: 3px;
          background-color: #fff;
          cursor: pointer;
          transition: all 0.2s;
        }
        .leftBtn {
          .b1 {
            background-color: #fe4d45;
            color: #fff;
            &:hover {
              opacity: 0.9;
            }
          }
          .b2 {
            border: 1px solid rgba(254, 77, 69, 1);
            color: #fe4d45;
            margin: 0 8px;
            &:hover {
              background-color: #fe4d45;
              color: #fff;
            }
          }
          .b3 {
            border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
            color: rgba(0, 0, 0, 0.65);
            &:hover {
              border: 1px solid #fe4d45;
              color: #fe4d45;
              background-color: #fff4f4;
            }
          }
        }
      }
      .elTable {
        margin-top: 20px;
        .desc {
          flex-shrink: 0;
          // width: 0;
          span {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .span1 {
            cursor: default;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .operation {
          cursor: pointer;
          color: #7f85e9;
          &:hover {
            color: #fe4d45;
          }
        }
      }
      .table {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        width: 100%;
        th {
          box-sizing: border-box;
          display: flex;
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding-left: 12px;
          text-align: left;
          background-color: #fafafa;
          font-size: 14px;
          color: #333;
        }
        tbody {
          display: flex;
          flex-direction: column;
          td {
            height: 100px;
            margin-top: 16px;
            .tit {
              box-sizing: border-box;
              padding-left: 12px;
              height: 40px;
              line-height: 40px;
              background-color: #fafafa;
              color: #666;
              font-size: 14px;
            }
            .tableCnt {
              box-sizing: border-box;
              padding: 10px 0 10px 40px;
              display: flex;
              align-items: center;
              border: 1px solid rgba(246, 246, 246, 1);
              color: #666;
              font-size: 14px;
              p {
                margin: 0;
              }
              .desc {
                flex-shrink: 0;
                width: 0;
                span {
                  display: inline-block;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .span {
                  cursor: default;
                }
                .span1 {
                  cursor: default;
                  &:hover {
                    text-decoration: underline;
                  }
                }
              }
              .info {
                display: flex;
                flex-direction: column;
                padding-left: 20px;
                .box {
                  .hover-show {
                    display: none;
                    position: absolute;
                    left: 0%;
                    top: 50%;
                    text-align: center;
                    transform: translate(0, -50%);
                    color: #fff;
                    cursor: pointer;
                    padding: 1px 10px;
                    border-radius: 4px;
                  }
                  &:hover {
                    .hover-show {
                      display: inline-block;
                    }
                  }
                }
                .box2 {
                  .hover-show {
                    display: none;
                    position: absolute;
                    left: 0%;
                    top: 50%;
                    text-align: center;
                    transform: translate(0, -50%);
                    color: #fff;
                    cursor: pointer;
                    padding: 1px 10px;
                    border-radius: 4px;
                  }
                  &:hover {
                    .hover-show {
                      display: inline-block;
                    }
                  }
                }
              }
              .handle {
                width: 60px;
                @media screen and (min-width: 1500px) and (max-width: 1700px) {
                }
                .operation {
                  cursor: pointer;
                  color: #7f85e9;
                  &:hover {
                    color: #fe4d45;
                  }
                }

                span {
                  cursor: pointer;
                  margin-right: 20px;
                  &:last-child {
                    margin: 0;
                  }
                }
              }
            }
          }
        }
      }
      .pagination {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}
.urgingLink {
  .item {
    display: flex;
    height: 32px;
    margin-top: 32px;
    &:last-child {
      margin-top: 24px;
    }
    .link {
      flex: 1;
      box-sizing: border-box;
      padding-left: 8px;
      height: 32px;
      line-height: 32px;
      background: rgba(246, 246, 246, 1);
      color: #333;
      font-size: 13px;
    }
    .copyBtn {
      flex-shrink: 0;
      width: 108px;
      height: 32px;
      background-color: #fe4d45;
      color: #fff;
      text-align: center;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.remarks {
  p {
    margin: 20px 0 8px 0;
    color: #333;
    font-size: 14px;
  }
  .footBtns {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    .cancelBtn {
      width: 98px;
      height: 32px;
      line-height: 32px;
      margin-right: 8px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #999;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        border: 1px solid #fe4d45;
        color: #fe4d45;
      }
    }
    .confirmBtn {
      width: 98px;
      height: 32px;
      line-height: 32px;
      background: rgba(254, 77, 69, 1);
      color: #fff;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.JoinBackList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  .tipsBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    .tips {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
  .btnBox {
    display: flex;
    align-items: center;
    justify-content: center;
    .cancelBtn {
      width: 98px;
      height: 32px;
      line-height: 32px;
      margin-right: 8px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #999;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        border: 1px solid #fe4d45;
        color: #fe4d45;
      }
    }
    .confirmBtn {
      width: 98px;
      height: 32px;
      line-height: 32px;
      background: rgba(254, 77, 69, 1);
      color: #fff;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.orderDetails {
  box-sizing: border-box;
  padding: 20px 0 20px;
  .tips {
    box-sizing: border-box;
    height: 32px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    margin: 0 0 20px 0;
    background: rgba(250, 250, 250, 1);
    color: #333333;
    font-size: 14px;
    i {
      width: 3px;
      height: 14px;
      margin-right: 8px;
      background-color: #fe4d45;
      border-radius: 3px;
    }
  }
  .details {
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    span {
      width: 33.3%;
      margin-bottom: 12px;
      color: #333;
      position: relative;
      font-size: 14px;
      &:last-child {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
  /deep/ .row {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04) !important;
  }
  /deep/ .el-table--small td {
    padding: 16px 0;
  }
}
</style>
